/**
 * The words the page shows for connection health (D-137), in one place with no component or style
 * import, so the journeys that prove them (tests/e2e/real/connection-health.spec.ts) read the same
 * strings the components render rather than a copy that could drift.
 */

/**
 * The header dot's words while live updates reconnect with the server answering (rule 2,
 * @CONN-HEALTH-001 and 003).
 */
export const RECONNECTING_LABEL =
  'Live updates reconnecting, the server is reachable';

/**
 * The overlay's warning while the server cannot be reached (rule 3, @CONN-HEALTH-002). It replaced
 * "Your changes are safe locally", which nothing made true: work typed into a form lives only in
 * the page, and the page is exactly what closing or refreshing throws away.
 */
export const OFFLINE_WARNING =
  "Don't close or refresh this page while it is offline, or any work you haven't saved will be lost.";

/**
 * The one short notice for a request that got no answer while the server answers its check (rule 8,
 * @CONN-HEALTH-009, D-144). The page shows nothing of its own; this is the whole message.
 */
export const UNANSWERED_REQUEST_NOTICE =
  'The server did not answer that request.';

/**
 * The on-screen notice for "server fine, live updates failing", the architect's condition put
 * plainly (rule 6, @CONN-HEALTH-004).
 */
export const LIVE_UPDATES_FAILING_NOTICE =
  'Live updates are not reaching this browser, although the server is reachable. A developer may need to investigate this.';

/**
 * What a keyed create page says when the server answered its create from the record of one already
 * carried out, with different values (rule 10, "Changed after the answer was lost", @CONN-HEALTH-018;
 * D-148 amended 2026-09-30). The person changed the form after their first press lost its answer;
 * the first press had landed, so the page opens that record and tells them their change was not
 * saved, so they make it on the record itself. The words name no domain concept, so one sentence
 * serves every keyed create.
 */
export const CHANGED_RECORD_NOTICE =
  'This was already saved before your change. Your change was not saved; make it on the record now open.';

/** The same, for an appended note: the first note stands, once, and the edited text was not added. */
export const CHANGED_NOTE_NOTICE =
  'This note was already added before your change. The edited text was not added.';
